import $ from "jquery"

$(document).ready(function() {
    // Use event delegation to handle clicks on thumbnails
    // This works even if elements are added dynamically or script loads before DOM is ready
    $(document).on('click', '.js-shorts-thumbnail', function(e) {
        e.preventDefault();
        
        const $button = $(this);
        const $shortsYt = $button.closest('.shorts__yt');
        const $iframe = $shortsYt.find('.shorts__embeed');
        const ytUrl = $shortsYt.data('yt');

        // Handle previously active video - stop it by resetting src to empty
        $('.shorts__yt.shorts__yt-active .shorts__embeed').attr('src', '');

        // Remove active class from all and show all thumbnails
        $('.shorts__yt').removeClass('shorts__yt-active');
        $('.js-shorts-thumbnail').fadeIn();

        // Add active class to current video container
        $shortsYt.addClass('shorts__yt-active');
        
        // Set iframe source with autoplay parameters
        if ($iframe.length && $iframe[0] && ytUrl) {
            // Add required parameters for YouTube embed
            const params = new URLSearchParams();
            params.set('autoplay', '1');
            params.set('mute', '1');
            params.set('origin', window.location.origin);
            params.set('enablejsapi', '0');
            
            // Build the final URL
            // const finalUrl = ytUrl + '?' + params.toString();
            const finalUrl = themeData.themeUrl + '/static/youtube.html?v=' + ytUrl + '&' + params.toString();
            
            console.log('Loading video:', finalUrl); // Debug
            $iframe[0].src = finalUrl;
        }

        // Hide thumbnail after short delay
        setTimeout(function(){
            $('.shorts__yt.shorts__yt-active .js-shorts-thumbnail').fadeOut();
        }, 200);
    });
});